import React, { useRef, useState, useEffect } from "react";
import { Card } from "@mui/material";
import { Link } from "react-router-dom";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import Footer from "components/Footer";

import { useUserController } from "context/user";
import { useMaterialUIController } from "context";
import { useDevice } from "context/device";

import Api from "Api/Api";
import trainingMatrix from "assets/images/trainingMatrix.png";
import styles from "./styles";

function Home() {
  const [videos, setVideos] = useState(null);
  const fetchRef = useRef(false);

  const [userController] = useUserController();
  const { user } = userController;

  const [controller] = useMaterialUIController();
  const { spanish } = controller;

  const device = useDevice();

  useEffect(() => {
    if (!videos && !fetchRef.current) {
      Api.getAllCats()
        .then((res) => {
          setVideos(res.data.reverse());
          fetchRef.current = true;
        })
        .catch((err) => {
          console.error("Failed to fetch videos:", err);
          setVideos([]);
        });
    }
  }, [videos]);

  const appLabel =
    process.env.REACT_APP_APP_INSTANCE === "CREWBELT" ? "Crewbelt" : "Marathon";
  const trainingTitle = spanish
    ? `Entrenamiento de Seguridad para ${appLabel}`
    : `${appLabel} Safety Training`;

  if (!user || !videos) {
    return (
      <DashboardLayout>
        <MDBox py={3}>
          You must be logged in to access this page, redirecting you to the login page...
        </MDBox>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={0}>
        <Card>
          <MDBox p={3} lineHeight={1} height="80vh" sx={{ overflow: "scroll" }}>
            <MDTypography variant="h5">{trainingTitle}</MDTypography>

            <MDBox pt={2} lineHeight={1}>
              <div
                style={
                  device === "mobile"
                    ? styles.linkContainerMobile
                    : styles.linkContainer
                }
              >
                {videos.map((video, i) => {
                  const slug = video.title.toLowerCase().replace(/\s+/g, "");

                  const isAllowed =
                    !video.isDeleted &&
                    (user.Admin === "Admin+" ||
                      video.id !== "105f5a00-8896-4171-b1cc-ba786e501265");

                  if (!isAllowed) return null;

                  const videoStyle =
                    device === "mobile"
                      ? {
                        ...styles.videoLinkMobile,
                        backgroundColor: video.color || "#f9f9f9",
                      }
                      : {
                        ...styles.videoLink,
                        backgroundColor: video.color || "#f9f9f9",
                      };

                  return (
                    <div key={i} style={videoStyle}>
                      <Link
                        to={`/videos/${slug}?id=${video.id}`}
                        style={styles.link}
                      >
                        {spanish && video.spanish ? video.spanish : video.title}
                      </Link>
                    </div>
                  );
                })}
              </div>

              {process.env.REACT_APP_APP_INSTANCE === "MARATHON" && <><MDTypography variant="h5">
                {spanish ? "Matriz de Entrenamiento" : "Training Matrix"}
              </MDTypography>

              <div style={styles.trainingMatrix}>
                <img
                  src={trainingMatrix}
                  alt="Training Matrix"
                  style={{height: "100%"}}
                />
              </div></>}
            </MDBox>
          </MDBox>
        </Card>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Home;
